export function WarningBadge({ level }) {
  if (level === "dac_biet_nguy_hiem")
    return (
      <span
        data-testid="badge-danger"
        className="inline-flex items-center px-2.5 py-1 text-xs font-black uppercase tracking-wide border rounded-sm bg-red-500/20 text-red-400 border-red-500 shadow-[0_0_10px_rgba(230,0,0,0.25)]"
      >
        Đặc biệt nguy hiểm
      </span>
    );
  return (
    <span
      data-testid="badge-warning"
      className="inline-flex items-center px-2.5 py-1 text-xs font-bold uppercase tracking-wide border rounded-sm bg-amber-500/10 text-amber-400 border-amber-500/50"
    >
      Cảnh báo
    </span>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pending: ["Chờ duyệt", "bg-zinc-500/10 text-zinc-300 border-zinc-600"],
    approved: ["Đã duyệt", "bg-green-500/10 text-green-400 border-green-600/50"],
    rejected: ["Từ chối", "bg-red-500/10 text-red-400 border-red-600/50"],
  };
  const [label, cls] = map[status] || map.pending;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-semibold border rounded-sm ${cls}`}>
      {label}
    </span>
  );
}
